import React from 'react';
import {Redirect} from 'react-router';
import config from '../../../../config';
import {getPermissions} from '../../../../utils/General';
import ManagerHome from './ManagerHome';
import OperatorHome from './OperatorHome';
import './index.css';

/*
 * The first screen after signing in.
 *
 * It used to be the internal chats, for everybody, and unconditionally: the
 * fallback route redirected there whether or not the company even had that
 * feature, so a company without INTERNAL_CHATS landed on a page that was not in
 * its own menu.
 *
 * Who sees which version is decided by the management permission rather than by
 * role name - that is how the rest of the panel already thinks (see isManager in
 * SideNav), and it keeps owner and admin together without naming them.
 */
const Home = ({user, company}) => {
    const features = company.tariff && company.tariff.features ? company.tariff.features : [];

    /*
     * Without the statistics feature there are no numbers to build either
     * version out of, so the landing stays what it was for those companies
     * rather than becoming an empty page.
     */
    if (features.indexOf(config.features.STATISTICS) === -1) {
        const fallback = features.indexOf(config.features.INTERNAL_CHATS) !== -1
            ? '/dashboard/chat/' + config.platformsMap.company
            : '/dashboard/chat/all';

        return <Redirect to={fallback}/>;
    }

    return getPermissions(user).indexOf(config.permissions.management) !== -1
        ? <ManagerHome user={user} company={company}/>
        : <OperatorHome user={user} company={company}/>;
};

export default Home;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/home/index.jsx